import { useCallback, useEffect, useState } from 'react';
import { MultiSelectProperty as MultiSelectProp } from '../../peregrineFlowInterfaces';
import { NodePropertyProp } from '../NodePropertyPane';
import { MenuItem, Select, SelectChangeEvent, Checkbox, OutlinedInput, ListItemText, Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

function MultiSelectProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as MultiSelectProp;
    const [value, setValue] = useState<string[]>(p.value ? p.value.map(v => v.toString()) : []);

    useEffect(() => {
        setValue(p.value ? p.value.map(v => v.toString()) : []);
    }, [p]);

    const onValueChange = useCallback((event: SelectChangeEvent<string[]>) => {
        const {
            target: { value },
        } = event;
        const newValue = typeof value === 'string' ? value.split(',') : value;
        p.value = newValue.map(v => (isNaN(Number(v)) ? v : Number(v)));
        onChange?.(p);
        setValue(newValue);
    }, [p, onChange]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <Select
                multiple
                fullWidth
                value={value}
                onChange={onValueChange}
                input={<OutlinedInput />}
                renderValue={(selected) => selected.join(', ')}
            >
                {p.options.map((v) => (
                    <MenuItem key={v.toString()} value={v.toString()}>
                        <Checkbox checked={value.indexOf(v.toString()) > -1} />
                        <ListItemText primary={v.toString()} />
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}

export default MultiSelectProperty;
